export default "__VITE_ASSET__B_mI0D$5__"